import { DateTime } from "luxon";

function sortDate(dates: string[], format = "yyyy-MM-dd") {
  const sortedDates = [...dates].sort((a, b) => {
    const da = DateTime.fromFormat(a, format).toMillis();

    const db = DateTime.fromFormat(b, format).toMillis();
    return da - db;
  });
  return sortedDates;
}

function formatDateRangeWeek(rangeString: string): string {
  const [startStr, endStr] = rangeString.split("--");

  const start = DateTime.fromFormat(startStr, "yyyy-MM-dd");
  const end = DateTime.fromFormat(endStr, "yyyy-MM-dd");

  if (!start.isValid || !end.isValid) return "Invalid date range";

  if (start.month === end.month) {
    return `${start.toFormat("MMM d")} - ${end.toFormat("d yyyy")}`;
  }

  return `${start.toFormat("MMM d")} - ${end.toFormat("MMM d yyyy")}`;
}

export const getPrevPeriodDateRange = ({
  startDate,
  endDate,
  statTest,
  restrictedDate,
}: any) => {
  let start, end;
  if (startDate && endDate) {
    start = DateTime.fromFormat(startDate, "yyyy-MM-dd");
    end = DateTime.fromFormat(endDate, "yyyy-MM-dd");
  }

  let prevPeriodStartDate;
  let prevPeriodEndDate;
  if (start && end) {
    if (statTest === "POP") {
      const numberOfDays = end.diff(start, "days").days + 1;
      prevPeriodStartDate = start.minus({ days: numberOfDays });
      prevPeriodEndDate = start.minus({ days: 1 });
    } else if (statTest === "YOY") {
      prevPeriodStartDate = start.minus({ years: 1 });
      prevPeriodEndDate = end.minus({ years: 1 });
    }
  }

  if (
    restrictedDate &&
    prevPeriodStartDate &&
    prevPeriodStartDate < DateTime.fromISO(restrictedDate)
  ) {
    prevPeriodStartDate = DateTime.fromISO(restrictedDate);
  }

  if (
    restrictedDate &&
    prevPeriodEndDate &&
    prevPeriodEndDate < DateTime.fromISO(restrictedDate)
  ) {
    prevPeriodEndDate = DateTime.fromISO(restrictedDate);
  }

  return {
    prevPeriodStartDate: prevPeriodStartDate?.toFormat("MM/dd/yyyy"),
    prevPeriodEndDate: prevPeriodEndDate?.toFormat("MM/dd/yyyy"),
  };
};



export { formatDateRangeWeek };

export default sortDate;
